(function () {

    'use strict';

    FileSelectionController.$inject = [
        '$rootScope',
        '$scope',
        '$document',
        '$filter',
        'growl',
        'fileNameValidationService',
        'fileUploadStorageService',
        'maximumUploadSize',
        'maximumNumberOfFilesPerAction'
    ];

    function FileSelectionController($rootScope,
        $scope,
        $document,
        $filter,
        growl,
        fileNameValidationService,
        fileUploadStorageService,
        maximumUploadSize,
        maximumNumberOfFilesPerAction) {
        var initialStorageAvailable = 0;
        var sizeOfFilesSelected = 0;

        var vm = this;

        vm.fileDragHover = fileDragHover;
        vm.fileDrop = fileDrop;
        vm.fileSelect = fileSelect;

        vm.autoScroll = autoScroll;
        vm.getListItemClass = getListItemClass;
        vm.getWkIcon = getWkIcon;
        vm.removeFile = removeFile;

        vm.filesToProcess = [];
        vm.filesProcessed = [];
        vm.filesBeingUploaded = [];
        vm.filesNotExist = [];
        vm.isFileSelectionHidden = false;
        vm.isUploadInProgress = false;

        initialize();

        function initialize() {
            fileUploadStorageService.getStorageAvailable()
                .then(function (storageAvailable) {
                    initialStorageAvailable = storageAvailable;
                });
        }

        function stopDefaultEventHandling(e) {
            e.stopPropagation();
            e.preventDefault();
        }

        function updateDragAndDropUiEffect(e) {
            var body = $document.find('body');
            e.type === "dragover" ? body.addClass('drag-and-drop-hover') : body.removeClass('drag-and-drop-hover');

            $scope.$apply();
        }

        function fileDragHover(e) {
            stopDefaultEventHandling(e);

            if (vm.isUploadInProgress) {
                e.originalEvent.dataTransfer.dropEffect = 'none';
                return;
            }

            updateDragAndDropUiEffect(e);
        }

        function fileDrop(e) {
            stopDefaultEventHandling(e);

            if (vm.isUploadInProgress) {
                return;
            }

            updateDragAndDropUiEffect(e);

            if (e.originalEvent.dataTransfer) {
                var items = e.originalEvent.dataTransfer.items;
                if (items) {
                    for (var i = 0; i < items.length; i++) {
                        if (!items[i].webkitGetAsEntry().isFile) {
                            growl.error('We\'re sorry, but a folder cannot be shared.');
                            return;
                        }
                    }
                }

                var files = e.originalEvent.dataTransfer.files;

                addFiles(files);
            }
        }

        /**
         * Returns an array with the list of invalid extensions.  E.g. [".exe", ".zip"]
         * @returns {array} An array of extensions with leading periods.
         */
        function getInvalidExtensions() {
            return fileNameValidationService
                .getInvalidExtensions()
                .map(function (extension) {
                    return `.${extension}`;
                });
        }

        function getFilesWithValidFilename(files) {
            var filesWithValidFilenames = [];

            for (var i = 0; i < files.length; i++) {
                if (fileNameValidationService.isValid(files[i].name)) {
                    filesWithValidFilenames.push(files[i]);
                }
            }

            return filesWithValidFilenames;
        }

        /**
         * Determine if any of the file names have ASCII HTML in the name.
         * @param {file} files The files to check.
         * @returns {boolean} true if any file names have ASCII HTML in name, false otherwise.
         */
        function hasFileNamesWithAsciiHtmlInName(files) {
            for (const file of files) {
                if (fileNameValidationService.hasAsciiHtmlInName(file.name)) {
                    return true;
                }
            }

            return false;
        }

        function fileSelect(e) {
            var files = e.target.files;
            if (files) {
                addFiles(files);
            }
        }

        function addFiles(files) {
            if (vm.filesToProcess.length + files.length > maximumNumberOfFilesPerAction) {
                growl.error('You cannot upload more than ' + maximumNumberOfFilesPerAction + ' files at once.');
                return;
            }

            var i;
            var totalSize = 0;

            for (i = 0; i < files.length; i++) {
                totalSize += files[i].size;
            }

            if ((sizeOfFilesSelected + totalSize) > initialStorageAvailable) {
                growl.error('The file(s) selected exceed the total storage you have available.');
                return;
            }

            sizeOfFilesSelected += totalSize;

            if (hasFileNamesWithAsciiHtmlInName(files)) {
                growl.error('You cannot share files with ASCII HTML in the name.');
                return;
            }

            for (i = 0; i < files.length; i++) {
                if (files[i].size === 0) {
                    growl.error('We\'re sorry, but 0 byte files cannot be shared.');
                    return;
                }

                if (files[i].size > maximumUploadSize) {
                    var text = $filter('fileSize')(maximumUploadSize);
                    growl.error("We're sorry, but files " + text + " or larger cannot be shared.");
                    return;
                }
            }

            var filesWithValidFilenames = getFilesWithValidFilename(files);

            if (files.length !== filesWithValidFilenames.length) {
                growl.error('We\'re sorry, but you cannot share the following types: ' + getInvalidExtensions().join(', '));
                return;
            }

            var filesToUpload = [];
            for (i = 0; i < filesWithValidFilenames.length; i++) {
                vm.filesToProcess.push({ 'file': filesWithValidFilenames[i] });
                filesToUpload.push(filesWithValidFilenames[i]);
            }
            if (filesToUpload.length > 0) {
                $rootScope.$broadcast('add-files', filesToUpload);
            }
            $scope.$apply();
        }

        function autoScroll() {
            var scrollableArea = $('#file-upload-status');
            var heightOfSingleElement = scrollableArea.find('li').outerHeight(true);
            var heightOfViewableArea = scrollableArea.outerHeight();
            var scrollTop = ((vm.filesProcessed.length * (heightOfSingleElement)) - heightOfViewableArea + heightOfSingleElement);
            scrollableArea[0].scrollTop = scrollTop;
        }

        function getListItemClass(status) {
            switch (status) {
                case 'success':
                    return 'list-group-item-success';
                case 'error':
                    return 'list-group-item-danger';
                default:
                    return 'list-group-item-info';
            }
        }

        function getWkIcon(status) {
            switch (status) {
                case 'success':
                    return 'file-check';
                case 'error':
                    return 'forbid';
                default:
                    return undefined;
            }
        }

        function removeFile(index) {
            sizeOfFilesSelected -= vm.filesToProcess[index].size;
            vm.filesToProcess.splice(index, 1);
            $rootScope.$broadcast('remove-file', index);
        }

        $scope.$on('pre-upload-files', function () {
            vm.isFileSelectionHidden = true;
            vm.isUploadInProgress = true;
        });

        $scope.$on('file-upload-started', function (event, args) {
            var file = args.file;
            var length = vm.filesToProcess.length;
            removeItemFromList(vm.filesToProcess, file);
            if (length !== vm.filesToProcess.length) {
                vm.filesToProcess = vm.filesToProcess;
                vm.filesBeingUploaded.push({ 'file': file, 'progress': 0 });
                vm.autoScroll();
            }
        });

        $scope.$on('file-upload-completed', function (event, args) {
            var file = args.file;
            var status = args.status;
            var length = vm.filesBeingUploaded.length;
            removeItemFromList(vm.filesBeingUploaded, file);
            if (length !== vm.filesBeingUploaded.length) {
                vm.filesBeingUploaded = vm.filesBeingUploaded;
                vm.filesProcessed.push({ 'file': file, 'status': status, 'reason': args.reason === undefined ? '' : args.reason });
            }
        });

        $scope.$on('file-upload-progress', function (event, args) {
            var file = args.file;
            var progress = Math.round(args.progress);
            for (var i = 0; i < vm.filesBeingUploaded.length; i++) {
                if (vm.filesBeingUploaded[i].file === file) {
                    vm.filesBeingUploaded[i].progress = progress;
                }
            }
        });

        $scope.$on('all-files-handled', function () {
            handleUnprocessedFiles();
        });

        function handleUnprocessedFiles() {
            for (var i = 0; i < vm.filesToProcess.length; i++) {
                var file = vm.filesToProcess[i].file;
                vm.filesProcessed.push({ 'file': file, 'status': 'error', 'reason': 'The file no longer exists.' });
            }
            vm.filesToProcess = [];
            vm.autoScroll();
        }

        function removeItemFromList(list, value) {
            for (var i = 0; i < list.length; i++) {
                var item = list[i];
                if (JSON.stringify(fileToJson(item.file)) === JSON.stringify(fileToJson(value))) {
                    list.splice(i, 1);
                    break;
                }
            }

            return list;
        }

        function fileToJson(file) {
            return {
                'lastModified': file.lastModified,
                'lastModifiedDate': file.lastModifiedDate,
                'name': file.name,
                'size': file.size,
                'type': file.type
            };
        }
    }

    module.exports = FileSelectionController;
})();